<template lang="pug">
yz-filter-menu(label="Category" :is-active="!!selectedCategory" :display-value="selectedCategory || ''" @clear="onClear" @apply="onApply")
  div
    .d-flex.text-sm.py-3.px-4
      yz-checkbox(:input-value="medication" @change="onSelectCategory('medication', $event)")
      .ml-4 Medication
    v-divider.basic300
  div
    .d-flex.text-sm.py-3.px-4
      yz-checkbox(:input-value="equipment" @change="onSelectCategory('equipment', $event)")
      .ml-4 Equipment
    v-divider.basic300
  div
    .d-flex.text-sm.py-3.px-4
      yz-checkbox(:input-value="consumable" @change="onSelectCategory('consumable', $event)")
      .ml-4 Consumable
    v-divider.basic300
  div.pb-2
    .d-flex.text-sm.py-3.px-4
      yz-checkbox(:input-value="service" @change="onSelectCategory('service', $event)")
      .ml-4 Service
</template>

<script>
export default {
  props: {
    filter: { type: Object, default: () => ({}) },
    checkInitialValue: { type: Boolean, default: false }
  },
  data: () => ({
    medication: false,
    equipment: false,
    consumable: false,
    service: false,
    tempSelectedCategory: null,
    selectedCategory: null
  }),
  watch: {
    filter: {
      handler () {
        if (!this.filter.key) this.clearData()
      }
    }
  },
  mounted () {
    this.setData()
  },
  methods: {
    setData () {
      if (this.checkInitialValue && this.filter.key) {
        this.selectedCategory = this.filter.value
        this.onSelectCategory(this.selectedCategory, true)
      }
    },
    onSelectCategory (category, value) {
      if (!value) {
        this.tempSelectedCategory = null
        return
      }
      this.medication = false
      this.equipment = false
      this.consumable = false
      this.service = false
      this[category] = true
      this.tempSelectedCategory = category
    },
    onClear () {
      this.clearData()
      this.$emit('update:filter', {})
    },
    clearData () {
      this.medication = false
      this.equipment = false
      this.consumable = false
      this.service = false
      this.selectedCategory = null
      this.tempSelectedCategory = null
    },
    onApply () {
      this.selectedCategory = this.tempSelectedCategory
      this.$emit('update:filter', { key: 'category', value: this.selectedCategory })
    }
  }
}
</script>
